export const ROUTES = {
  HOME: '/',
  SEARCH: '/search',
  SEARCH_V1: '/searchv1',
};

export const MIN_SKELETON_MS = 1000;
export const HITS_PER_PAGE = 10;

export const ARIA_LABELS = {
  SEARCH_INPUT: 'Search EE Business',
  SEARCH_BUTTON: 'Submit search',
};

export const SizeToSkeletonCount = {
  small: 2,
  medium: 4,
  large: 6,
};

export const PRIMARY_BAR_HEIGHT = 50;

export const DEFAULT_CART_ID_KEY = 'guestCartId';

export const VISIBLE_ROWS = 4;
export const ROW_HEIGHT = 56;
export const FALLBACK_IMG = '/placeholder.png';
